var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.visible)?_c('Header'):_vm._e(),(_vm.visible)?_c('sideNav'):_vm._e(),_c('transition',{attrs:{"name":"moveInUp"}},[_c('router-view')],1),(_vm.visible)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }